/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import * as yup from "yup";
import Navbar from "../../components/Nabvar";
import Footer from "../../components/Footer";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { GET_ROLES, REGISTER_USER } from "../../services/auth";
import { GET_COMPANIES } from "../../services/contract/contracts";
import {
  GET_CATALOG_USERS,
  GET_CATALOG_CLIENTS,
  GET_CATALOG_EXPERTS,
  GET_CATALOG_ADJUSTERS,
  GET_CATALOG_BRANCHES,
  GET_CATALOG_EXCHANGE,
} from "../../services/catalogs";
import { useMutation, useLazyQuery } from "@apollo/client";

import {
  Container,
  Header,
  HeaderWrapper,
  ModuleContainer,
  ModuleTitle,
  ModuleWrapper,
  Divider,
  SearchContainer,
  SearchContainerMobile,
  TextNotification,
} from "./StylesCatalogs";
import { SearchBar } from "../../components/ui";
import ModalContainer from "../../components/ModalContainer";
import Categories from "./categories";
import ListWrapper from "./dataList";
import {
  ModalCoin,
  ModalClient,
  ModalRamo,
  ModalAjustador,
  ModalEditarUsuario,
  ModalExpert,
  ModalNewUser,
} from "./formModals";

const schema = yup.object({
  email: yup
    .string()
    .required("Ingresa un email valido")
    .email("Ingresa un email valido"),
  password: yup
    .string("Ingresa una contraseña valida")
    .min(6, "Ingresa una contraseña valida"),
});

export default function Catalogs() {
  const [showModalAddUser, setShowModalAddUser] = useState(false);
  const [showModalEditUser, setShowModalEditUser] = useState(false);
  const [showModalDeleteUser, setShowModalDeleteUser] = useState(false);
  const [showModalCreateClient, setShowModalCreateClient] = useState(false);
  const [showModalCreateExpert, setShowModalCreateExpert] = useState(false);
  const [showModalCreateAdapter, setShowModalCreateAdapter] = useState(false);
  const [showModalCreateBranch, setShowModalCreateBranch] = useState(false);
  const [showModalCreateCoin, setShowModalCreateCoin] = useState(false);
  const [showModalEditExpert, setShowModalEditExpert] = useState(false);
  const [showModalEditAdapter, setShowModalEditAdapter] = useState(false);
  const [showModalEditBranch, setShowModalEditBranch] = useState(false);
  const [showModalEditCoin, setShowModalEditCoin] = useState(false);
  const [showModalEditClient, setShowModalEditClient] = useState(false);
  const [showModalDeleteClient, setShowModalDeleteClient] = useState(false);
  const [showModalDeleteExpert, setShowModalDeleteExpert] = useState(false);
  const [showModalDeleteAdapter, setShowModalDeleteAdapter] = useState(false);
  const [showModalDeleteBranch, setShowModalDeleteBranch] = useState(false);
  const [showModalDeleteCoin, setShowModalDeleteCoin] = useState(false);
  const [valueToSearch, setValueToSearch] = useState("");

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  /*=====NOTIFICACIONES CREAR ====*/

  const create = {
    view: false,
    created: false,
    customMessage: undefined,
  };

  const [userCreated, setUserCreated] = useState(create);
  const [clientCreated, setClientCreated] = useState(create);
  const [expertCreated, setExpertCreated] = useState(create);
  const [adapterCreated, setAdapterCreated] = useState(create);
  const [branchCreated, setBranchCreated] = useState(create);
  const [coinCreated, setCoinCreated] = useState(create);

  /*=====NOTIFICACIONES ACTUALIZAR ====*/

  const update = {
    view: false,
    updated: false,
    customMessage: undefined,
  };

  const [updateUser, setUpdateUser] = useState(update);
  const [updateClient, setUpdateClient] = useState(update);
  const [updateExpert, setUpdateExpert] = useState(update);
  const [updateAdapter, setUpdateAdapter] = useState(update);
  const [updateBranch, setUpdateBranch] = useState(update);
  const [updateCoin, setUpdateCoin] = useState(update);

  /*=====NOTIFICACIONES BORRAR ====*/

  const deleteMessage = {
    view: false,
    deleted: false,
    customMessage: undefined,
  };

  const [deleteUser, setDeleteUser] = useState(deleteMessage);
  const [deleteClient, setDeleteClient] = useState(deleteMessage);
  const [deleteExpert, setDeleteExpert] = useState(deleteMessage);
  const [deleteAdapter, setDeleteAdapter] = useState(deleteMessage);
  const [deleteBranch, setDeleteBranch] = useState(deleteMessage);
  const [deleteCoin, setDeleteCoin] = useState(deleteMessage);

  const [doCreateUser, resultsCreateUser] = useMutation(REGISTER_USER);
  const [roles, setRoles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([{}]);
  const [experts, setExperts] = useState([{}]);
  const [fixers, setFixers] = useState([{}]);
  const [branches, setBranches] = useState([]);
  const [exchange, setExchange] = useState([]);
  const [status, setStatus] = useState("");
  const [catalogView, setCatalogView] = useState("Users");
  const [currentId, setCurrentId] = useState("");
  const [activeIconUser, setActiveIconUser] = useState(true);
  const [activeIconClient, setActiveIconClient] = useState(false);
  const [activeIconExpert, setActiveIconExpert] = useState(false);
  const [activeIconAdapter, setActiveIconAdapter] = useState(false);
  const [activeIconBranch, setActiveIconBranch] = useState(false);
  const [activeIconCoin, setActiveIconCoin] = useState(false);
  const handleTabChange = (newValue) => {
    setCatalogView(newValue);

    switch (newValue) {
      case "Users":
        setActiveIconUser(!activeIconUser);
        setActiveIconClient(false);
        setActiveIconExpert(false);
        setActiveIconAdapter(false);
        setActiveIconBranch(false);
        setActiveIconCoin(false);
        break;
      case "Clients":
        setActiveIconClient(!activeIconClient);
        setActiveIconUser(false);
        setActiveIconExpert(false);
        setActiveIconAdapter(false);
        setActiveIconBranch(false);
        setActiveIconCoin(false);
        break;
      case "Experts":
        setActiveIconExpert(!activeIconExpert);
        setActiveIconUser(false);
        setActiveIconClient(false);
        setActiveIconAdapter(false);
        setActiveIconBranch(false);
        setActiveIconCoin(false);
        break;
      case "Fixers":
        setActiveIconAdapter(!activeIconAdapter);
        setActiveIconUser(false);
        setActiveIconClient(false);
        setActiveIconExpert(false);
        setActiveIconBranch(false);
        setActiveIconCoin(false);
        break;
      case "Branches":
        setActiveIconBranch(!activeIconBranch);
        setActiveIconUser(false);
        setActiveIconClient(false);
        setActiveIconExpert(false);
        setActiveIconAdapter(false);
        setActiveIconCoin(false);
        break;
      case "Coin":
        setActiveIconCoin(!activeIconCoin);
        setActiveIconUser(false);
        setActiveIconClient(false);
        setActiveIconExpert(false);
        setActiveIconAdapter(false);
        setActiveIconBranch(false);
        break;
      default:
        setActiveIconUser(!activeIconUser);
    }
  };

  const onSubmit = (data) => {
    const dataForSubmit = {
      email: data.email,
      password: data.password,
      rol_usuario_id: parseInt(data.rol),
      nombre: data.nombre,
      apellido: data.apellido,
    };
    doCreateUser({ variables: dataForSubmit });
  };

  const [getCatalogUsers] = useLazyQuery(GET_CATALOG_USERS, {
    fetchPolicy: "network-only",
    onCompleted({ getCatalogUsers }) {
      if (getCatalogUsers.statusCode === 200) {
        const result = getCatalogUsers.response;
        const names = result.map((e) => {
          return {
            name: `${e.nombre} ${e.apellido}`,
            email: e.email,
            usuario_id: e.usuario_id,
            nombre: e.nombre,
            apellido: e.apellido,
            rol_usuario_id: e.rol_usuario_id,
            empresa_id: e.empresa_id,
            empresa: e.empresa,
          };
        });
        setUsers(names);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getRoles] = useLazyQuery(GET_ROLES, {
    fetchPolicy: "network-only",
    onCompleted({ getRoles }) {
      if (getRoles.statusCode === 200) {
        const result = getRoles.response;
        const names = result.map((rol) => {
          return {
            label: rol.valor,
            value: rol.rol_usuario_id,
          };
        });
        //   console.log(getRoles.response);
        setRoles(names);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getCompany] = useLazyQuery(GET_COMPANIES, {
    onCompleted({ getCompany }) {
      if (getCompany.statusCode === 200) {
        const result = JSON.parse(getCompany.response);
        const names = result.map((company) => {
          return {
            value: company.nombre,
            label: company.nombre,
          };
        });
        setCompanies(names);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getCatalogClients] = useLazyQuery(GET_CATALOG_CLIENTS, {
    fetchPolicy: "network-only",
    onCompleted({ getCatalogClients }) {
      if (getCatalogClients.statusCode === 200) {
        const result = getCatalogClients.response;
        const names = result.map((client) => {
          return {
            nombre: client.nombre,
            cliente_id: client.cliente_id,
          };
        });
        setClients(names);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getCatalogExperts] = useLazyQuery(GET_CATALOG_EXPERTS, {
    fetchPolicy: "network-only",
    onCompleted({ getCatalogExperts }) {
      if (getCatalogExperts.statusCode === 200) {
        const result = getCatalogExperts.response;
        const names = result.map((e) => {
          return {
            experto_id: e.experto_id,
            name: e.nombre,
            company: e.sigla,
            rfc: e.rfc,
            email: e.email,
            address: e.direccion,
            cp: e.cp,
            state: e.estado,
            region: e.municipio,
            phone: e.telefono,
            razon_social: e.razon_social,
          };
        });
        setExperts(names);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getCatalogAdjusters] = useLazyQuery(GET_CATALOG_ADJUSTERS, {
    fetchPolicy: "network-only",
    onCompleted({ getCatalogAdjusters }) {
      if (getCatalogAdjusters.statusCode === 200) {
        const result = getCatalogAdjusters.response;
        const names = result.map((e) => {
          return {
            ajustador_id: e.ajustador_id,
            name: e.nombre,
            company: e.sigla,
            rfc: e.rfc,
            phone: e.telefono,
            email: e.email,
            address: e.direccion,
            cp: e.cp,
            region: e.municipio,
            state: e.estado,
            razon_social: e.razon_social,
          };
        });
        setFixers(names);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getCatalogBranches] = useLazyQuery(GET_CATALOG_BRANCHES, {
    fetchPolicy: "network-only",
    onCompleted({ getCatalogBranches }) {
      if (getCatalogBranches.statusCode === 200) {
        const result = getCatalogBranches.response;
        const names = result.map((client) => {
          return {
            nombre: client.valor,
            ramo_id: client.ramo_id,
          };
        });
        setBranches(names);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getCatalogExchangeTypes] = useLazyQuery(GET_CATALOG_EXCHANGE, {
    fetchPolicy: "network-only",
    onCompleted({ getCatalogExchangeTypes }) {
      if (getCatalogExchangeTypes.statusCode === 200) {
        const result = getCatalogExchangeTypes.response;
        const names = result.map((e) => {
          return {
            nombre: e.valor,
            tipo_cambio_id: e.tipo_cambio_id,
          };
        });
        setExchange(names);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  useEffect(() => {
    getCompany();
    getRoles();
    getCatalogClients();
    getCatalogUsers();
    getCatalogExperts();
    getCatalogAdjusters();
    getCatalogBranches();
    getCatalogExchangeTypes();
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (resultsCreateUser.data) {
      if (resultsCreateUser?.data?.createUser?.statusCode === 200) {
        setStatus("Success");
        reset({
          email: "",
          password: "",
          rol: "",
          nombre: "",
          apellido: "",
        });
      } else {
        setStatus("Error");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultsCreateUser]);

  useEffect(() => {
    if (showModalEditClient === true || showModalDeleteClient === true)
      setShowModalCreateClient(true);
  }, [showModalEditClient, showModalDeleteClient]);

  useEffect(() => {
    if (showModalEditExpert === true || showModalDeleteExpert === true)
      setShowModalCreateExpert(true);
  }, [showModalEditExpert, showModalDeleteExpert]);

  useEffect(() => {
    if (showModalEditAdapter === true || showModalDeleteAdapter === true)
      setShowModalCreateAdapter(true);
  }, [showModalEditAdapter, showModalDeleteAdapter]);

  useEffect(() => {
    if (showModalEditBranch === true || showModalDeleteBranch === true)
      setShowModalCreateBranch(true);
  }, [showModalEditBranch, showModalDeleteBranch]);

  useEffect(() => {
    if (showModalEditCoin === true || showModalDeleteCoin === true)
      setShowModalCreateCoin(true);
  }, [showModalEditCoin, showModalDeleteCoin]);

  useEffect(() => {
    if (showModalEditUser === true || showModalDeleteUser === true)
      setShowModalAddUser(true);
  }, [showModalEditUser, showModalDeleteUser]);

  const MessageSucces = ({ property, specificProperty, message }) => {
    const [resultMessage, setResultMessage] = useState(null);
    useEffect(() => {
      if (resultMessage === null) {
        setResultMessage(
          !specificProperty
            ? property.customMessage || "Hubo un error, inténtelo de nuevo"
            : property.customMessage || message
        );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <>{resultMessage}</>;
  };

  return (
    <>
      {/*=====NOTIFICACIONES POP-UP CREAR ====*/}
      <ModalContainer
        showModal={userCreated.view}
        closeModal={() =>
          setUserCreated({ view: false, created: false, customMessage: "" })
        }
      >
        <TextNotification created={userCreated.created}>
          <MessageSucces
            property={userCreated}
            specificProperty={userCreated.created}
            message={"Usuario agregado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={clientCreated.view}
        closeModal={() =>
          setClientCreated({ view: false, created: false, customMessage: "" })
        }
      >
        <TextNotification created={clientCreated.created}>
          <MessageSucces
            property={expertCreated}
            specificProperty={clientCreated.created}
            message={"Cliente agregado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={expertCreated.view}
        closeModal={() =>
          setExpertCreated({ view: false, created: false, customMessage: "" })
        }
      >
        <TextNotification created={expertCreated.created}>
          <MessageSucces
            property={expertCreated}
            specificProperty={expertCreated.created}
            message={"Experto Agregado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={adapterCreated.view}
        closeModal={() =>
          setAdapterCreated({ view: false, created: false, customMessage: "" })
        }
      >
        <TextNotification created={adapterCreated.created}>
          <MessageSucces
            property={adapterCreated}
            specificProperty={adapterCreated.created}
            message={"Ajustador Agregado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={branchCreated.view}
        closeModal={() =>
          setBranchCreated({ view: false, created: false, customMessage: "" })
        }
      >
        <TextNotification created={branchCreated.created}>
          <MessageSucces
            property={branchCreated}
            specificProperty={branchCreated.created}
            message={"Ramo Agregado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={coinCreated.view}
        closeModal={() =>
          setCoinCreated({ view: false, created: false, customMessage: "" })
        }
      >
        <TextNotification created={coinCreated.created}>
          <MessageSucces
            property={coinCreated}
            specificProperty={coinCreated.created}
            message={"Moneda Agregada"}
          />
        </TextNotification>
      </ModalContainer>
      {/*=====NOTIFICACIONES POP-UP ACTUALIZAR ====*/}
      <ModalContainer
        showModal={updateUser.view}
        closeModal={() =>
          setUpdateUser({ view: false, updated: false, customMessage: "" })
        }
      >
        <TextNotification created={updateUser.updated}>
          <MessageSucces
            property={updateUser}
            specificProperty={updateUser.updated}
            message={"Usuario actualizado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={updateClient.view}
        closeModal={() =>
          setUpdateClient({ view: false, updated: false, customMessage: "" })
        }
      >
        <TextNotification created={updateClient.updated}>
          <MessageSucces
            property={updateClient}
            specificProperty={updateClient.updated}
            message={"Cliente actualizado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={updateExpert.view}
        closeModal={() =>
          setUpdateExpert({ view: false, update: false, customMessage: "" })
        }
      >
        <TextNotification created={updateExpert.updated}>
          <MessageSucces
            property={updateExpert}
            specificProperty={updateExpert.updated}
            message={"Experto actualizado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={updateAdapter.view}
        closeModal={() =>
          setUpdateAdapter({ view: false, update: false, customMessage: "" })
        }
      >
        <TextNotification created={updateAdapter.updated}>
          <MessageSucces
            property={updateAdapter}
            specificProperty={updateAdapter.updated}
            message={"Ajustador actualizado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={updateBranch.view}
        closeModal={() =>
          setUpdateBranch({ view: false, update: false, customMessage: "" })
        }
      >
        <TextNotification created={updateBranch.updated}>
          <MessageSucces
            property={updateBranch}
            specificProperty={updateBranch.updated}
            message={"Ramo actualizado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={updateCoin.view}
        closeModal={() =>
          setUpdateCoin({ view: false, update: false, customMessage: "" })
        }
      >
        <TextNotification created={updateCoin.updated}>
          <MessageSucces
            property={updateCoin}
            specificProperty={updateCoin.updated}
            message={"Moneda actualizada"}
          />
        </TextNotification>
      </ModalContainer>
      {/*=====NOTIFICACIONES POP-UP BORRAR ====*/}
      <ModalContainer
        showModal={deleteUser.view}
        closeModal={() =>
          setDeleteUser({ view: false, deleted: false, customMessage: "" })
        }
      >
        <TextNotification created={deleteUser.deleted}>
          <MessageSucces
            property={deleteUser}
            specificProperty={deleteUser.deleted}
            message={"Usuario eliminado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={deleteClient.view}
        closeModal={() =>
          setDeleteClient({ view: false, deleted: false, customMessage: "" })
        }
      >
        <TextNotification created={deleteClient.deleted}>
          <MessageSucces
            property={deleteClient}
            specificProperty={deleteClient.deleted}
            message={"Cliente eliminado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={deleteExpert.view}
        closeModal={() =>
          setDeleteExpert({ view: false, deleted: false, customMessage: "" })
        }
      >
        <TextNotification created={deleteExpert.deleted}>
          <MessageSucces
            property={deleteExpert}
            specificProperty={deleteExpert.deleted}
            message={"Experto eliminado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={deleteAdapter.view}
        closeModal={() =>
          setDeleteAdapter({ view: false, deleted: false, customMessage: "" })
        }
      >
        <TextNotification created={deleteAdapter.deleted}>
          <MessageSucces
            property={deleteAdapter}
            specificProperty={deleteAdapter.deleted}
            message={"Ajustador eliminado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={deleteBranch.view}
        closeModal={() =>
          setDeleteBranch({ view: false, deleted: false, customMessage: "" })
        }
      >
        <TextNotification created={deleteBranch.deleted}>
          <MessageSucces
            property={deleteBranch}
            specificProperty={deleteBranch.deleted}
            message={"Ramo eliminado"}
          />
        </TextNotification>
      </ModalContainer>
      <ModalContainer
        showModal={deleteCoin.view}
        closeModal={() =>
          setDeleteCoin({ view: false, deleted: false, customMessage: "" })
        }
      >
        <TextNotification created={deleteCoin.deleted}>
          <MessageSucces
            property={deleteCoin}
            specificProperty={deleteCoin.deleted}
            message={"Moneda eliminada"}
          />
        </TextNotification>
      </ModalContainer>
      <Container>
        <Navbar />
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>
        {/*===== AGREGAR USUARIO ====*/}
        <ModalContainer
          showModal={showModalAddUser}
          closeModal={() => {
            setShowModalAddUser(false);
            setShowModalEditUser(false);
            setShowModalDeleteUser(false);
          }}
        >
          <ModalNewUser
            companies={companies}
            statusList={status}
            submitRef={handleSubmit(onSubmit)}
            roles={roles}
            setStatus={setStatus}
            closeModal={() => {
              setShowModalAddUser(false);
              setShowModalEditUser(false);
              setShowModalDeleteUser(false);
            }}
            user={users.find((user) => user.usuario_id === currentId)}
            showModalEditUser={showModalEditUser}
            showModalDeleteUser={showModalDeleteUser}
            getCatalogUsers={getCatalogUsers}
            setCreatedUser={setUserCreated}
            setUpdateUser={setUpdateUser}
            setDeleteUser={setDeleteUser}
          />
        </ModalContainer>

        {/*===== NUEVO CLIENTE ====*/}
        <ModalContainer
          showModal={showModalCreateClient}
          closeModal={() => {
            setShowModalCreateClient(false);
            setShowModalEditClient(false);
            setShowModalDeleteClient(false);
          }}
        >
          <ModalClient
            client={clients.find((client) => client?.cliente_id === currentId)}
            closeModal={() => {
              setShowModalCreateClient(false);
              setShowModalEditClient(false);
              setShowModalDeleteClient(false);
            }}
            showModalEditClient={showModalEditClient}
            showModalDeleteClient={showModalDeleteClient}
            getCatalogClients={getCatalogClients}
            setCreatedClient={setClientCreated}
            setUpdateClient={setUpdateClient}
            setDeleteClient={setDeleteClient}
          />
        </ModalContainer>

        {/*===== AGREGAR EXPERTO ====*/}
        <ModalContainer
          showModal={showModalCreateExpert}
          closeModal={async () => {
            await setShowModalCreateExpert(false);
            await setShowModalEditExpert(false);
            await setShowModalDeleteExpert(false);
          }}
        >
          <ModalExpert
            expert={experts.find((expert) => expert?.experto_id === currentId)}
            closeModal={async () => {
              await setShowModalCreateExpert(false);
              await setShowModalEditExpert(false);
              await setShowModalDeleteExpert(false);
            }}
            showModalEditExpert={showModalEditExpert}
            showModalDeleteExpert={showModalDeleteExpert}
            getCatalogExperts={getCatalogExperts}
            setExpertCreated={setExpertCreated}
            setUpdateExpert={setUpdateExpert}
            setDeleteExpert={setDeleteExpert}
          />
        </ModalContainer>

        {/*===== NUEVO AJUSTADOR  ====*/}
        <ModalContainer
          showModal={showModalCreateAdapter}
          closeModal={async () => {
            await setShowModalCreateAdapter(false);
            await setShowModalEditAdapter(false);
            await setShowModalDeleteAdapter(false);
          }}
        >
          <ModalAjustador
            adjuster={fixers.find(
              (ajustador) => ajustador?.ajustador_id === currentId
            )}
            closeModal={async () => {
              await setShowModalCreateAdapter(false);
              await setShowModalEditAdapter(false);
              await setShowModalDeleteAdapter(false);
            }}
            showModalEditAdapter={showModalEditAdapter}
            showModalDeleteAdapter={showModalDeleteAdapter}
            getCatalogAdjusters={getCatalogAdjusters}
            setAdapterCreated={setAdapterCreated}
            setUpdateAdapter={setUpdateAdapter}
            setDeleteAdapter={setDeleteAdapter}
          />
        </ModalContainer>

        {/*===== RAMO NUEVO  ====*/}
        <ModalContainer
          showModal={showModalCreateBranch}
          closeModal={() => {
            setShowModalCreateBranch(false);
            setShowModalEditBranch(false);
            setShowModalDeleteBranch(false);
          }}
        >
          <ModalRamo
            branch={branches.find((branch) => branch?.ramo_id === currentId)}
            closeModal={() => {
              setShowModalCreateBranch(false);
              setShowModalEditBranch(false);
              setShowModalDeleteBranch(false);
            }}
            showModalEditBranch={showModalEditBranch}
            showModalDeleteBranch={showModalDeleteBranch}
            getCatalogBranches={getCatalogBranches}
            setBranchCreated={setBranchCreated}
            setUpdateBranch={setUpdateBranch}
            setDeleteBranch={setDeleteBranch}
          />
        </ModalContainer>
        {/*===== NUEVA MONEDA  ====*/}
        <ModalContainer
          showModal={showModalCreateCoin}
          closeModal={() => {
            setShowModalCreateCoin(false);
            setShowModalEditCoin(false);
            setShowModalDeleteCoin(false);
          }}
        >
          <ModalCoin
            getCatalogExchangeTypes={getCatalogExchangeTypes}
            coin={exchange.find((coin) => coin?.tipo_cambio_id === currentId)}
            closeModal={() => {
              setShowModalCreateCoin(false);
              setShowModalEditCoin(false);
              setShowModalDeleteCoin(false);
            }}
            showModalEditCoin={showModalEditCoin}
            showModalDeleteCoin={showModalDeleteCoin}
            setCoinCreated={setCoinCreated}
            setUpdateCoin={setUpdateCoin}
            setDeleteCoin={setDeleteCoin}
          />
        </ModalContainer>
        {/*===== CONTENIDO  ====*/}
        <ModuleWrapper>
          <SearchContainerMobile>
            <SearchBar placeholder={"Buscar"} />
          </SearchContainerMobile>
          <ModuleContainer>
            <SearchContainer>
              <ModuleTitle>Buscar</ModuleTitle>
              {window.innerWidth > 768 && (
                <SearchBar
                  nullable={true}
                  onChange={(val) => {
                    setValueToSearch(val);
                  }}
                  placeholder={"Buscar"}
                />
              )}
            </SearchContainer>
            <div>
              <Divider />
            </div>
            {/* Vista de todas las categorias */}
            <Categories
              handleTabChange={handleTabChange}
              dataView={{
                setShowModalAddUser,
                setShowModalCreateClient,
                setShowModalCreateExpert,
                setShowModalCreateAdapter,
                setShowModalCreateBranch,
                setShowModalCreateCoin,
              }}
              activeIconUser={activeIconUser}
              activeIconClient={activeIconClient}
              activeIconExpert={activeIconExpert}
              activeIconAdapter={activeIconAdapter}
              activeIconBranch={activeIconBranch}
              activeIconCoin={activeIconCoin}
            />

            {/* Listas de datos de cada categoría */}
            <ListWrapper
              valueToSearch={valueToSearch}
              setCurrentId={setCurrentId}
              viewModal={{
                setShowModalEditUser,
                setShowModalDeleteUser,
                setShowModalEditExpert,
                setShowModalEditAdapter,
                setShowModalEditBranch,
                setShowModalEditCoin,
                setShowModalEditClient,
                setShowModalDeleteClient,
                setShowModalDeleteExpert,
                setShowModalDeleteAdapter,
                setShowModalDeleteBranch,
                setShowModalDeleteCoin,
              }}
              dataToMap={{
                catalogView,
                users,
                clients,
                experts,
                fixers,
                branches,
                exchange,
              }}
            />
          </ModuleContainer>
        </ModuleWrapper>
      </Container>
      <Footer />
    </>
  );
}
